import { SelectUnit } from '../types'
import { getUnits, getUnitsClimate, getUnitsCovered } from '../selectors'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import { actions } from '../reducer'

export const SelectUnitsCallbacks = () => {
  const dispatch = useDispatch()
  const units = useSelector(getUnits)
  const unitsClimate = useSelector(getUnitsClimate) as SelectUnit[]
  const unitsCovered = useSelector(getUnitsCovered) as SelectUnit[]
  return {
    onChange: React.useCallback(
      (e: React.ChangeEvent<{ value: unknown }>, item: SelectUnit) => {
        const _val = String(e.target?.value ?? '')
        let _units = cloneDeep(units ?? []) as SelectUnit[]
        let _unitsClimate = cloneDeep(unitsClimate ?? [])
        let _unitsCovered = cloneDeep(unitsCovered ?? [])
        if (!item.isClimate && !item.isCovered) {
          _units = _units.map((x) => {
            if (x.size === item.size) x.value = _val
            return x
          })
        } else if (item.isClimate) {
          _unitsClimate = _unitsClimate.map((x) => {
            if (x.size === item.size) x.value = _val
            return x
          })
        } else {
          _unitsCovered = _unitsCovered.map((x) => {
            if (x.size === item.size) x.value = _val
            return x
          })
        }
        dispatch(
          actions.onAllUnits({
            units: _units,
            unitsClimate: _unitsClimate,
            unitsCovered: _unitsCovered,
          })
        )
        const combined = _units.concat(_unitsClimate).concat(_unitsCovered)
        const selected: SelectUnit[] = []
        combined.forEach((x) => {
          if (x.value !== '0') selected.push(x)
        })
        dispatch(actions.onSelectedUnits(selected))
      },
      [units, unitsClimate, unitsCovered, dispatch]
    ),
  }
}
